export default ".spinner{color:#191826;font-size:25px}.spinner--dark{color:#fff}";